import SubBanner from '../../comm/SubBanner'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Col, Nav, Row, Tab } from 'react-bootstrap';
import { reqData } from '../../../js/server';
import { pwCheck } from '../../../js/util';

function FindAccount(props) {
    const dispatch = useDispatch()
    const history = useHistory()
    const [userid, setUserid] = useState(null)
    const [userTel0, setUserTel0] = useState(null)
    const [userTel1, setUserTel1] = useState(null)
    const [userTel2, setUserTel2] = useState(null)
    const [userTel02, setUserTel02] = useState(null)
    const [userTel12, setUserTel12] = useState(null)
    const [userTel22, setUserTel22] = useState(null)
    const [luseno, setLuseno] = useState(null)
    const [lusenoPasswd, setLusenoPasswd] = useState(null)
    const [new_passwd, setNew_passwd] = useState(null)
    const [new_re_passwd, setNew_re_passwd] = useState(null)
    const [isSend, setisSend] = useState(false)
    const [isSendPasswd, setisSendPasswd] = useState(false)
    const [isResultFindId, setisResultFindId] = useState(false)
    const [resultFindId, setResultFindId] = useState(null)

    const fnSetTel = (e) => {
        if (e.target.id === 'inputHp0') {
            setUserTel0(e.target.value)
            if (e.target.value.length >= 3) {
                document.getElementById('inputHp0').value = e.target.value.slice(0, 3)
                document.getElementById('inputHp1').focus()
            }
        } else if (e.target.id === 'inputHp1') {
            setUserTel1(e.target.value)
            if (e.target.value.length >= 4) {
                document.getElementById('inputHp1').value = e.target.value.slice(0, 4)
                document.getElementById('inputHp2').focus()
            }
        } else if (e.target.id === 'inputHp2') {
            setUserTel2(e.target.value)
            if (e.target.value.length >= 4) {
                document.getElementById('inputHp2').value = e.target.value.slice(0, 4)
            }
        }
    }

    const fnSetTel2 = (e) => {
        if (e.target.id === 'inputHp02') {
            setUserTel02(e.target.value)
            if (e.target.value.length >= 3) {
                document.getElementById('inputHp02').value = e.target.value.slice(0, 3)
                document.getElementById('inputHp12').focus()
            }
        } else if (e.target.id === 'inputHp12') {
            setUserTel12(e.target.value)
            if (e.target.value.length >= 4) {
                document.getElementById('inputHp12').value = e.target.value.slice(0, 4)
                document.getElementById('inputHp22').focus()
            }
        } else if (e.target.id === 'inputHp22') {
            setUserTel22(e.target.value)
            if (e.target.value.length >= 4) {
                document.getElementById('inputHp22').value = e.target.value.slice(0, 4)
            }
        }
    }

    const fnSendLuseNo = () => {
        if (userTel0 && userTel1 && userTel2) {
            const userTel = `${userTel0}${userTel1}${userTel2}`
            const jsonData = {
                "servicename": "IDSearch",
                "hp": userTel
            }
            dispatch({ type: 'loadingChange', payload: true })
            reqData(jsonData).then((res) => {
                if (res.data.result === 'OK') {
                    alert('인증번호가 발송되었습니다.')
                    setisSend(true)
                    setTimeout(() => {
                        setisSend(false)
                    }, 30000)
                } else {
                    alert(res.data.msg)
                }
            }).catch((err) => {
                console.error(err)
            }).finally(() => {
                dispatch({ type: 'loadingChange', payload: false })
            })
        } else {
            alert('휴대폰번호를 모두 입력해 주세요.')
            document.querySelector('#inputHp0').focus()
        }
    }

    const fnSendLuseNo2 = () => {
        if (userid && userTel02 && userTel12 && userTel22) {
            const userTel = `${userTel02}${userTel12}${userTel22}`
            const jsonData = {
                "servicename": "IDSearch",
                "hp": userTel
            }
            dispatch({ type: 'loadingChange', payload: true })
            reqData(jsonData).then((res) => {
                if (res.data.result === 'OK') {
                    alert('인증번호가 발송되었습니다.')
                    setisSendPasswd(true)
                    setTimeout(() => {
                        setisSendPasswd(false)
                    }, 30000)
                } else {
                    alert(res.data.msg)
                }
            }).catch((err) => {
                console.error(err)
            }).finally(() => {
                dispatch({ type: 'loadingChange', payload: false })
            })
        } else {
            alert('아이디와 휴대폰번호를 모두 입력해 주세요.')
            document.querySelector('#inputHp02').focus()
        }
    }

    const fnFindIdClick = () => {
        if (luseno && userTel0 && userTel1 && userTel2) {
            const userTel = `${userTel0}${userTel1}${userTel2}`
            const jsonData = {
                "servicename": "IDSearchOK",
                "hp": userTel,
                "luseno": luseno
            }
            dispatch({ type: 'loadingChange', payload: true })
            reqData(jsonData).then((res) => {
                console.log(res.data)
                if (res.data.result === 'OK') {
                    setisResultFindId(true)
                    setResultFindId(res.data.userid)
                } else {
                    alert(res.data.msg)
                }
            }).catch((err) => {
                console.error(err)
            }).finally(() => {
                dispatch({ type: 'loadingChange', payload: false })
            })
        }
    }

    const fnChangePwClick = () => {
        const userPwState = pwCheck(new_passwd)

        if (!userid) {
            alert('사용자아이디를 입력해 주세요.')
        } else if (!userTel02 || !userTel12 || !userTel22) {
            alert('휴대폰번호를 입력해 주세요.')
        } else if (!lusenoPasswd) {
            alert('인증번호를 입력해 주세요.')
        } else if (!new_passwd) {
            alert('새로운 비밀번호를 입력해 주세요.')
        } else if (!new_re_passwd) {
            alert('새로운 비밀번호 확인을 입력해 주세요.')
        } else if (!userPwState) {
            alert('비밀번호는 영문,숫자 포함 6~20자내 사용이 가능합니다.')
        } else if (new_passwd !== new_re_passwd) {
            alert('새로운 비밀번호와 확인란의 입력값이 다릅니다.')
        } else {
            if (window.confirm('비밀번호 변경 요청을 하시겠습니까?')) {
                const userTel = `${userTel02}${userTel12}${userTel22}`
                const jsonData = {
                    "servicename": "PWSearchOK",
                    "userid": userid,
                    "hp": userTel,
                    "luseno": lusenoPasswd,
                    "new_passwd": new_passwd
                }
                dispatch({ type: 'loadingChange', payload: true })
                reqData(jsonData).then((res) => {
                    console.log(res.data)
                    if (res.data.result === 'OK') {
                        alert('비밀번호 변경이 완료되었습니다.\n\n로그인 해 주세요.')
                        history.push('/Login')
                    } else {
                        alert(res.data.msg)
                    }
                }).catch((err) => {
                    console.error(err)
                }).finally(() => {
                    dispatch({ type: 'loadingChange', payload: false })
                })
            }
        }
    }

    useEffect(() => {
        dispatch({ type: 'pageChange', payload: { 'sub01': '회원관리', 'sub02': '아이디/비밀번호 찾기' } })
        dispatch({ type: 'authUpdate', payload: null })
        dispatch({ type: 'loadingChange', payload: true })

        setTimeout(() => {
            localStorage.removeItem('userinfo')

            dispatch({ type: 'loadingChange', payload: false })
        }, 500)
    },
        // eslint-disable-next-line
        []);

    return (
        <>
            <SubBanner id="member" aPage="" />

            <section className="appoinment section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 col-md-2"></div>

                        <div className="col-lg-6 col-md-8">

                            <div className="row">
                                <div className="col-lg-12">
                                    <p>아이디 혹은 비밀번호 분실시 휴대전화번호를 통한 인증으로 찾을 수 있습니다.</p>
                                </div>
                            </div>

                            <div className="row round-box">
                                <div className="col-lg-12">
                                    <Tab.Container defaultActiveKey="findId">
                                        <Row>
                                            <Col sm={12}>
                                                <Nav variant="pills" className="mb-3">
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="findId" style={{ cursor: 'pointer' }}>아이디 찾기</Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="findPw" style={{ cursor: 'pointer' }}>비밀번호 찾기</Nav.Link>
                                                    </Nav.Item>
                                                </Nav>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm={12}>
                                                <Tab.Content>
                                                    <Tab.Pane eventKey="findId">
                                                        <div className="row pt-20">
                                                            <div className="col-lg-12">
                                                                <div className="form-group">
                                                                    <label className="form-control-label">휴대폰번호</label>
                                                                    <div className="input-group">
                                                                        <input
                                                                            id="inputHp0"
                                                                            name="inputHp0"
                                                                            type="number"
                                                                            className="form-control"
                                                                            onChange={fnSetTel} />
                                                                        <input
                                                                            id="inputHp1"
                                                                            name="inputHp1"
                                                                            type="number"
                                                                            className="form-control"
                                                                            onChange={fnSetTel} />
                                                                        <input
                                                                            id="inputHp2"
                                                                            name="inputHp2"
                                                                            type="number"
                                                                            className="form-control"
                                                                            onChange={fnSetTel} />
                                                                        {
                                                                            (isSend)
                                                                                ? (
                                                                                    <button
                                                                                        className="btn btn-custom-search"
                                                                                        type="button"
                                                                                        disabled
                                                                                    >
                                                                                        30초 후 가능
                                                                                    </button>
                                                                                )
                                                                                : (
                                                                                    <button
                                                                                        className="btn btn-custom-search"
                                                                                        type="button"
                                                                                        onClick={fnSendLuseNo}
                                                                                    >
                                                                                        인증번호 발송
                                                                                    </button>
                                                                                )
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="row">
                                                            <div className="col-lg-12">
                                                                <div className="form-group">
                                                                    <label className="form-control-label">인증번호</label>
                                                                    <input
                                                                        id="inputUserid"
                                                                        name="inputUserid"
                                                                        type="text"
                                                                        className="form-control"
                                                                        maxLength="8"
                                                                        onChange={(e) => setLuseno(e.target.value)} />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {
                                                            (isResultFindId)
                                                                ? (
                                                                    <div className="row pb-20">
                                                                        <div className="col-lg-12">
                                                                            고객님의 ID는 "{resultFindId || ''}"입니다.
                                                                        </div>
                                                                    </div>
                                                                )
                                                                : null
                                                        }

                                                        <div className="row">
                                                            <div className="col-12 text-center">
                                                                <span
                                                                    className="btn btn-main btn-icon btn-round-full"
                                                                    onClick={fnFindIdClick}
                                                                >아이디찾기</span>
                                                            </div>
                                                        </div>
                                                    </Tab.Pane>
                                                    <Tab.Pane eventKey="findPw">
                                                        <div className="row pt-20">
                                                            <div className="col-12">
                                                                <div className="form-group">
                                                                    <label className="form-control-label">사용자아이디</label>
                                                                    <input
                                                                        id="inputUserid"
                                                                        name="inputUserid"
                                                                        type="text"
                                                                        className="form-control"
                                                                        maxLength="20"
                                                                        onChange={(e) => setUserid(e.target.value)} />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="row">
                                                            <div className="col-12">
                                                                <div className="form-group">
                                                                    <label className="form-control-label">휴대폰번호</label>
                                                                    <div className="input-group">
                                                                        <input
                                                                            id="inputHp02"
                                                                            name="inputHp02"
                                                                            type="number"
                                                                            className="form-control"
                                                                            onChange={fnSetTel2} />
                                                                        <input
                                                                            id="inputHp12"
                                                                            name="inputHp12"
                                                                            type="number"
                                                                            className="form-control"
                                                                            onChange={fnSetTel2} />
                                                                        <input
                                                                            id="inputHp22"
                                                                            name="inputHp22"
                                                                            type="number"
                                                                            className="form-control"
                                                                            onChange={fnSetTel2} />
                                                                        {
                                                                            (isSendPasswd)
                                                                                ? (
                                                                                    <button
                                                                                        className="btn btn-custom-search"
                                                                                        type="button"
                                                                                        disabled
                                                                                    >
                                                                                        30초 후 가능
                                                                                    </button>
                                                                                )
                                                                                : (
                                                                                    <button
                                                                                        className="btn btn-custom-search"
                                                                                        type="button"
                                                                                        onClick={fnSendLuseNo2}
                                                                                    >
                                                                                        인증번호 발송
                                                                                    </button>
                                                                                )
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="row">
                                                            <div className="col-lg-12">
                                                                <div className="form-group">
                                                                    <label className="form-control-label">인증번호</label>
                                                                    <input
                                                                        id="inputUserid"
                                                                        name="inputUserid"
                                                                        type="text"
                                                                        className="form-control"
                                                                        maxLength="8"
                                                                        onChange={(e) => setLusenoPasswd(e.target.value)} />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="row">
                                                            <div className="col-12">
                                                                <div className="form-group">
                                                                    <label className="form-control-label">새로운 비밀번호</label>
                                                                    <input
                                                                        type="password"
                                                                        id="new_passwd"
                                                                        name="new_passwd"
                                                                        className="form-control"
                                                                        maxLength="20"
                                                                        onChange={(e) => setNew_passwd(e.target.value)}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="row pb-20">
                                                            <div className="col-12">
                                                                <div className="form-group">
                                                                    <label className="form-control-label">새로운 비밀번호 확인</label>
                                                                    <input
                                                                        type="password"
                                                                        id="new_re_passwd"
                                                                        name="new_re_passwd"
                                                                        className="form-control"
                                                                        maxLength="20"
                                                                        onChange={(e) => setNew_re_passwd(e.target.value)}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="row">
                                                            <div className="col-12 text-center">
                                                                <span
                                                                    className="btn btn-main btn-icon btn-round-full"
                                                                    onClick={fnChangePwClick}
                                                                >비밀번호 변경</span>
                                                            </div>
                                                        </div>
                                                    </Tab.Pane>
                                                </Tab.Content>
                                            </Col>
                                        </Row>
                                    </Tab.Container>
                                </div>

                            </div>

                        </div>

                        <div className="col-lg-3 col-md-2"></div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default FindAccount